import { getDataFromServer } from '../../util';
import { TM_FRAUD_SOURCE_STRINGS } from '../../../util/GlobalConstant';

export class TmCommonModules {
  constructor(baseURL, httpHeaders, preventionBaseUrl) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
    this.preventionBaseUrl = preventionBaseUrl;
  }

  fetchTMCommonTransactionHistoryAPI = async (payload) => {
    const { customerId, isSmartAssessment, ...params } = payload;
    let url = '';

    if (isSmartAssessment) {
      url = `${this.baseURL}/customers/triggeredTransactionHistory`;
    } else {
      url = `${this.baseURL}/customers/${customerId}/transactionHistory`;
    }

    return await getDataFromServer(url, this.httpHeaders, params);
  };

  downloadTMCommonTransactionHistoryAPI = async (payload) => {
    const { customerId, isSmartAssessment, ...params } = payload;
    let url = '';

    if (isSmartAssessment) {
      url = `${this.baseURL}/customers/triggeredTransactionHistory`;
    } else {
      url = `${this.baseURL}/customers/${customerId}/transactionHistory`;
    }

    return await getDataFromServer(url, this.httpHeaders, {
      ...params,
      offset: 0,
      limit: 5000
    });
  };

  fetchTMCommonTransactionTriggeredTypologiesAPI = async (payload) => {
    const { alertId, ...params } = payload;
    const url = `${this.baseURL}/alerts/${alertId}/triggeredTypologies`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchTMCommonScoreExplainablity = async (payload) => {
    const { alertId, ...params } = payload;
    const url = `${this.baseURL}/alerts/${alertId}/modelScoreExplainability`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchPreventionCommonScoreExplainablity = async (payload) => {
    const { alertId, ...params } = payload;
    const url = `${this.preventionBaseUrl}/alerts/${alertId}/scoreExplanation`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchTMCommonPeerAndProfileGraph = async (payload) => {
    const { alertId, ...params } = payload;
    const url = `${this.baseURL}/alerts/${alertId}/riskIndicatorGraph`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchTypologyList = async (payload) => {
    const { alertId, ...params } = payload;
    const url = `${this.baseURL}/alerts/${alertId}/triggeredTypologies`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchVariantsListForAlertId = async (payload) => {
    const { alertId, ...params } = payload;
    const url = `${this.baseURL}/alerts/${alertId}/triggeredRules`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchRiskIndicatorList = async (payload) => {
    const { alertId, typologyId, modelId, ...params } = payload;
    const url = `${this.baseURL}/alerts/${alertId}/riskIndicators?typologyId=${typologyId}&modelId=${modelId}`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  fetchTMCommonCustomerLoanDetails = async (payload) => {
    const { customerId, ...params } = payload;
    const url = `${this.baseURL}/customers/${customerId}/loans`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };
}
